// src/jira/plan/types.ts
var JiraPlanAriResourceOwner = "jira", JiraPlanAriResourceType = "plan";

export {
  JiraPlanAriResourceOwner,
  JiraPlanAriResourceType
};
